var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons /  Webapp UI"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8681_138652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8681_138652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "alarm_on",
    d: "M8.71563 12.9127L12.9531 8.67519L11.8844 7.60645L8.71563 10.7752L7.12188 9.18145L6.05313 10.2502L8.71563 12.9127ZM9.50313 17.0002C8.56563 17.0002 7.68763 16.8222 6.86913 16.4662C6.05013 16.1097 5.33763 15.6282 4.73163 15.0217C4.12513 14.4157 3.64363 13.7032 3.28713 12.8842C2.93113 12.0657 2.75313 11.1877 2.75313 10.2502C2.75313 9.3127 2.93113 8.43445 3.28713 7.61545C3.64363 6.79695 4.12513 6.08445 4.73163 5.47795C5.33763 4.87195 6.05013 4.39095 6.86913 4.03495C7.68763 3.67845 8.56563 3.5002 9.50313 3.5002C10.4406 3.5002 11.3189 3.67845 12.1379 4.03495C12.9564 4.39095 13.6689 4.87195 14.2754 5.47795C14.8814 6.08445 15.3626 6.79695 15.7191 7.61545C16.0751 8.43445 16.2531 9.3127 16.2531 10.2502C16.2531 11.1877 16.0751 12.0657 15.7191 12.8842C15.3626 13.7032 14.8814 14.4157 14.2754 15.0217C13.6689 15.6282 12.9564 16.1097 12.1379 16.4662C11.3189 16.8222 10.4406 17.0002 9.50313 17.0002ZM4.70313 2.2627L5.75313 3.3127L2.56563 6.5002L1.51562 5.4502L4.70313 2.2627ZM14.3031 2.2627L17.4906 5.4502L16.4406 6.5002L13.2531 3.3127L14.3031 2.2627ZM9.50313 15.5002C10.9656 15.5002 12.2061 14.9907 13.2246 13.9717C14.2436 12.9532 14.7531 11.7127 14.7531 10.2502C14.7531 8.78769 14.2436 7.54695 13.2246 6.52795C12.2061 5.50945 10.9656 5.0002 9.50313 5.0002C8.04063 5.0002 6.80013 5.50945 5.78163 6.52795C4.76263 7.54695 4.25313 8.78769 4.25313 10.2502C4.25313 11.7127 4.76263 12.9532 5.78163 13.9717C6.80013 14.9907 8.04063 15.5002 9.50313 15.5002Z",
    fill: "#1DA687"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGreen);
export default __webpack_public_path__ + "static/media/clock-green.86d17a86a6d5a16a0b0a9ba9126f9e1a.svg";
export { ForwardRef as ReactComponent };